/*  ========================================================================
    # Scripts - Post Progress Bar
    ========================================================================  */

/**
 * Script that handles the progress bar on post pages.
 */
const PostProgressBar = {
  cfg: {
    postContent: document.getElementById('post-content'),
    postProgressBar: document.getElementById('post-progress-bar'),
    header: document.getElementById('header-main')
  },

  /**
   * Handle Post Progress Bar behavior
   */
  handleProgressBar() {
    window.addEventListener('scroll', () => {
      this.cfg.postProgressBar.style = '--progress: ' + this.calcProgress() * 100 + '%';
    });
  },

  /*
   * Calc the progress
   */
  calcProgress() {
    const progress =
      (window.scrollY - this.cfg.header.offsetHeight) /
      (this.cfg.postContent.offsetHeight + this.cfg.postContent.offsetTop);
    return progress > 0 ? progress : 0;
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.postContent) {
      this.handleProgressBar();
    }
  }
};

export default PostProgressBar;
